import { defineComponent as _defineComponent } from 'vue'
import { useBriefcaseStore } from "@/pinia/briefcase";
import { computed, nextTick, ref } from "vue";
import { BriefcaseFolder, VignetteRoutes } from "@/types";
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { RouterService } from "@/services";
import { Dictionary } from "vue-router/types/router";
import { useRoute, useRouter } from "vue-router/composables";
import DeleteBriefcaseFolderDialog from "@/components/dialogs/DeleteBriefcaseFolderDialog.vue";
import AddNewBriefcaseFolderDialog from "@/components/dialogs/AddNewBriefcaseFolderDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BriefcaseFolderSelect',
  props: {
    selectedFolders: null
  },
  emits: ["update-folders", "update-folder"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update-folders", folderIds: number[]): void;
  (e: "update-folder", folderId: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedFolders?: number[] | number;
};





const isMultiple = computed(
  () =>
    props.selectedFolders !== undefined && Array.isArray(props.selectedFolders)
);
const isInSelectMode = computed(() => props.selectedFolders !== undefined);
// makes typescript happy when modifying currentFolder
const isInMultipleSelectModeGuard = (
  currentFolderId: undefined | number[] | number
): currentFolderId is number[] => {
  return isInSelectMode.value && isMultiple.value;
};

const router = useRouter();
const route = useRoute();

const briefcaseStore = useBriefcaseStore();
const briefcaseFolders = computed(() => briefcaseStore.flatFoldersSorted);
const currentFolderId = computed(() =>
  isInSelectMode.value
    ? props.selectedFolders
    : briefcaseStore.meta.currentFolderId
);

const handleChange = (folderId: number | number[]) => {
  if (isInSelectMode.value) {
    if (isMultiple.value) {
      emit("update-folders", folderId as number[]);
    } else {
      emit("update-folder", folderId as number);
    }
  } else {
    navigateToFolder(folderId as number);
  }
};
const navigateToFolder = (folderId: number) => {
  const isSubFolder = folderId !== briefcaseStore.meta.defaultFolderId;
  const params: Dictionary<string> = isSubFolder
    ? { folderId: String(folderId) }
    : {};

  briefcaseStore.meta.currentFolderId = folderId;
  RouterService.navigateByName(
    router,
    isSubFolder ? VignetteRoutes.BriefcaseFolder : VignetteRoutes.Briefcase,
    route.query,
    params
  );
};

const handleNewFolder = (folder: BriefcaseFolder) => {
  // If we are in multiple select mode, we want to push the new folder to the current folder which is the list of
  // currently selected folders.
  if (isInMultipleSelectModeGuard(currentFolderId.value)) {
    currentFolderId.value?.push(folder.id);
  } else {
    // if we are in single select mode we want to emit the folder id to the parent component
    if (isInSelectMode.value && !isMultiple.value) {
      emit("update-folder", folder.id);
    }
  }
  displayAddFolderDialog.value = false;
};

const displayAddFolderDialog = ref(false);

const folderToBeDeleted = ref<BriefcaseFolder | null>(null);
const isDeleteFolderDialogOpen = ref(false);
const setFolderToBeDeletedAndDisplayDialog = (folder: BriefcaseFolder) => {
  folderToBeDeleted.value = folder;
  isDeleteFolderDialogOpen.value = true;
};
const handleCloseDeleteFolderDialog = () => {
  const isViewingFolderToDelete =
    folderToBeDeleted.value?.id === currentFolderId.value;
  folderToBeDeleted.value = null;
  isDeleteFolderDialogOpen.value = false;
  if (isViewingFolderToDelete) {
    nextTick(() => navigateToFolder(briefcaseStore.meta.defaultFolderId));
  }
};

return { __sfc: true,emit, props, isMultiple, isInSelectMode, isInMultipleSelectModeGuard, router, route, briefcaseStore, briefcaseFolders, currentFolderId, handleChange, navigateToFolder, handleNewFolder, displayAddFolderDialog, folderToBeDeleted, isDeleteFolderDialogOpen, setFolderToBeDeletedAndDisplayDialog, handleCloseDeleteFolderDialog, NjBtn, DeleteBriefcaseFolderDialog, AddNewBriefcaseFolderDialog }
}

})